export default "__VITE_ASSET__BTSOBGxy__"